import { EmploymentAvailabilityWeek } from './employment-availability-week.model';
import {
  addWeeks,
  endOfISOWeek,
  endOfMonth,
  isAfter,
  isBefore,
  startOfDay,
  startOfISOWeek,
} from 'date-fns';

export class EmploymentAvailabilityMonth {
  public weeks: Array<EmploymentAvailabilityWeek> = [];
  public startDate: Date;
  public endDate: Date;

  constructor(
    private inputStartDate: Date,
    earlyEndDate?: Date,
    breakFrom?: Date,
    breakTo?: Date,
  ) {
    this.startDate = startOfDay(inputStartDate);
    this.endDate = earlyEndDate ? earlyEndDate : endOfMonth(inputStartDate);
    let currentWeekStart = startOfISOWeek(inputStartDate);

    if (isBefore(currentWeekStart, this.inputStartDate)) {
      currentWeekStart = inputStartDate;
    }

    if (
      this.endDate &&
      currentWeekStart &&
      (!breakFrom ||
        !breakTo ||
        isBefore(currentWeekStart, breakFrom) ||
        isAfter(endOfISOWeek(currentWeekStart), breakTo))
    ) {
      while (isBefore(currentWeekStart, this.endDate)) {
        this.weeks.push(
          new EmploymentAvailabilityWeek(
            currentWeekStart,
            earlyEndDate,
            breakFrom,
            breakTo,
          ),
        );
        currentWeekStart = startOfISOWeek(addWeeks(currentWeekStart, 1));
      }
    }
  }
}
